import { useState, useEffect, useCallback } from 'react';
import { hrAPI } from '@/lib/api';
import { toast } from 'sonner';
import { addDays, startOfWeek, toISODate } from './scheduleUtils';

// Loads the expanded week schedule (+ approved PTO) for the week starting `monday`.
export const useWeekSchedule = (employeeId) => {
  const [monday, setMonday] = useState(startOfWeek());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const params = { start: toISODate(monday), end: toISODate(addDays(monday, 6)) };
      if (employeeId) params.employee_id = employeeId;
      const res = await hrAPI.weekSchedule(params);
      setData(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to load schedule');
      setData({ employees: [], shifts: [], time_off: [] });
    } finally {
      setLoading(false);
    }
  }, [monday, employeeId]);

  useEffect(() => { reload(); }, [reload]);

  return {
    monday, data, loading, reload,
    prevWeek: () => setMonday((m) => addDays(m, -7)),
    nextWeek: () => setMonday((m) => addDays(m, 7)),
    thisWeek: () => setMonday(startOfWeek()),
  };
};
